const chipPalette = [
  { bg: '#DBEAFE', text: '#1E40AF' },
  { bg: '#F3E8FD', text: '#6B21A8' },
  { bg: '#FEE2E2', text: '#A91B1B' },
  { bg: '#F3F4F6', text: '#3D3C42' },
  { bg: '#DCFCE7', text: '#166534' },
  { bg: '#E7E7E7', text: '#3D3C42' },
  { bg: '#E0F2FE', text: '#075985' },
  { bg: '#ECFCCB', text: '#3F6212' },
  { bg: '#FFE4E6', text: '#9F1239' },
  { bg: '#F3E8FF', text: '#7E22CE' },
  { bg: '#FFF7ED', text: '#9A3412' },
  { bg: '#E0E7FF', text: '#3730A3' },
  { bg: '#F1F5F9', text: '#334155' },
  { bg: '#FAE8FF', text: '#A21CAF' },
  { bg: '#CCFBF1', text: '#115E59' },
  { bg: '#FEF3C7', text: '#92400E' },
  { bg: '#E2E8F0', text: '#1E293B' },
  { bg: '#D1FAE5', text: '#065F46' },
  { bg: '#FFE4D6', text: '#9A3412' },
  { bg: '#FDE68A', text: '#78350F' },
];

export const getChipColorByIndex = (index: number): any =>
  chipPalette[index % chipPalette.length];
